import { render, staticRenderFns } from "./CollapsableMenuItem.vue?vue&type=template&id=2733636e&scoped=true&"
import script from "./CollapsableMenuItem.vue?vue&type=script&lang=js&"
export * from "./CollapsableMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./CollapsableMenuItem.vue?vue&type=style&index=0&id=2733636e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2733636e",
  null
  
)

export default component.exports